import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_41 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_42 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_43 = { class: "indicator-label" }
const _hoisted_44 = { class: "indicator-progress" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'banks'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateBank')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.bankSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bankNameArLang'),
                      modelValue: _ctx.bank.titleAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bank.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('bankNameEnLang'),
                      modelValue: _ctx.bank.titleEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bank.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.bankName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('name')), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "name",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('name'),
                          modelValue: _ctx.bank.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bank.name) = $event))
                        }, null, 8, ["placeholder", "modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "name" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('password')), 1),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_Field, {
                              type: "password",
                              name: "password",
                              autocomplete: "new-password",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('newPassword')
                            }, null, 8, ["placeholder"]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_ErrorMessage, { name: "password" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_Field, {
                              type: "password",
                              name: "verifyPassword",
                              autocomplete: "new-password",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('verifyPassword')
                            }, null, 8, ["placeholder"]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_ErrorMessage, { name: "verifyPassword" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('email')), 1),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_Field, {
                          type: "email",
                          name: "email",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('email'),
                          modelValue: _ctx.bank.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bank.email) = $event))
                        }, null, 8, ["placeholder", "modelValue"]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('adminAccess')) + ": ", 1),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      name: "isAdminAccess",
                      type: "checkbox",
                      modelValue: _ctx.bank.isAdminAccess,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bank.isAdminAccess) = $event)),
                      value: true,
                      "unchecked-value": false
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'banks'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_44, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_45
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}